import { Carousel } from 'src/components/Carousel/Carousel'
import { GiftSubscriptionCard } from 'src/components/GiftSubscription/GiftSubscriptionCard'
import { Headline } from 'src/components/Headline/Headline'
import { Text } from 'src/components/Text/Text'
import { config } from 'src/config'
import { groupBy } from 'src/functions/util/groupBy'

import styles from './GiftSubscriptionBuy.module.scss'

import type { SubscriptionPlan, SubscriptionPrice } from 'src/types/Subscription'

interface GiftSubscriptionBuyProps {
  plans: SubscriptionPlan[]
  prices: SubscriptionPrice[]
}

export const GiftSubscriptionBuy = ({ plans, prices }: GiftSubscriptionBuyProps) => {
  const sortedPlans = plans.sort((a, b) => a.external_name.localeCompare(b.external_name))

  const sortedPrices = prices.sort((a, b) => a.periodMonths - b.periodMonths)

  if (sortedPlans.length === 0) return <p>no valid subscription plan</p>

  const periods: Record<string, SubscriptionPrice[]> = groupBy(sortedPrices, 'periodMonths')

  return (
    <section className={styles.section} id="gift-subscription-configure">
      {/* eslint-disable-next-line @next/next/no-sync-scripts */}
      <script src="https://js.chargebee.com/v2/chargebee.js" data-cb-site={process.env.CHARGEBEE_API_SITE} />
      <div>
        <div className={styles.topHeadlineContainer}>
          <Headline variant="h2" className={styles.headline}>
            Konfiguriere hier dein individuelles Geschenkabo:
          </Headline>
          <Text className={styles.subText}>
            Monatliche Lieferung mit 2 unterschiedlichen 250 g Packungen Kaffeebohnen
          </Text>
        </div>
        <div>
          <Carousel
            variant="cards"
            slideSize={{ base: '85%', md: '20%' }}
            classNames={{ slide: styles.card }}
            mobileBreakpoint={config.breakpoints.xl}
            mobileInitialSlide={2}
          >
            {Object.values(periods).map((priceArray: SubscriptionPrice[], index) => (
              // eslint-disable-next-line react/no-array-index-key
              <GiftSubscriptionCard prices={priceArray} plans={sortedPlans} key={index} />
            ))}
          </Carousel>
          <div className={styles.deliveryInfoContainer}>
            <Text x-small>Alle Preise inkl. MwSt.</Text>
            <Text x-small>
              <b>Klimafreundlicher Versand</b>
            </Text>
          </div>
        </div>
      </div>
    </section>
  )
}
